import MyInspectionsComponent from '@/components/Pages/MyInspections.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/inspections',
  name: RouteNames.Inspections,
  component: MyInspectionsComponent,
};

export default route;
